<template>
  <div class="js-toggle-item-01 js-clear-01" id="anc-03" v-if="isShowPackage">
    <h2 class="hdg-page-02 js-toggle-hdg-01">
      <button
        type="button"
        class="js-toggle-ui-01"
        :aria-expanded="expander"
        @click="changeExpander(false)"
        id="expandPackageInfo"
      >
        <span>{{ $t("KYG021001.label.package_label") }}</span>
      </button>
    </h2>

    <div class="js-toggle-content-01 mt-03" :class="{ dblock: !expander }">
      <p class="txt-lead-02" v-if="invalidInput">
        <strong>{{ $t("Error.business.InputError") }}</strong>
      </p>

      <h3 class="hdg-page-03">
        <span>{{ $t("KYG021001.label.luggage_setting") }}</span>
      </h3>
      <h4 class="hdg-page-04">
        <span>{{ $t("KYG021001.label.export_info") }}</span>
      </h4>
      <fieldset class="form-fieldset-01">
        <legend class="flex">
          <span>{{ $t("KYG021001.label.actual_weight") }}</span
          ><strong class="required-01">{{
            $t("KYG021001.label.required")
          }}</strong>
        </legend>
        <div class="inner">
          <ul class="form-list-01">
            <li>
              <label class="form-input-01">
                <input-format-number
                  :placeholder="$t('KYG021001.label.placeholder_gross_weight')"
                  maxlength="7"
                  @input="isActiveGrossWeight = false"
                  @blur="isActiveGrossWeight = true"
                  v-model="$v.packageModel.grossWeight.$model"
                  fix-decimal="1"
                  :class="{
                    'form-error-01':
                      ($v.packageModel.grossWeight.$error &&
                        grossWeightIsReady) ||
                      errors.get(keyParams.grossWeight)
                  }"
                >
                </input-format-number>
                <span class="unit">
                  {{ dataInit.weightUnidCd }}
                </span>
              </label>
            </li>
          </ul>
        </div>
        <error-message
          v-if="grossWeightIsReady"
          :validate="$v.packageModel.grossWeight"
          :value="packageModel.grossWeight"
          :error="errors.get(keyParams.grossWeight)"
          :itemName="$t('KYG021001.label.actual_weight_label')"
          :overSizeLabel="
            serviceKbn === '01'
              ? $t('ParamMessage.OverSizeLabel01')
              : $t('ParamMessage.OverSizeLabel03')
          "
        ></error-message>
      </fieldset>

      <fieldset class="form-fieldset-01">
        <legend class="flex">
          <span>{{ $t("KYG021001.label.net_weight") }}</span>
        </legend>
        <div class="inner">
          <ul class="form-list-01">
            <li>
              <label class="form-input-01">
                <input-format-number
                  :placeholder="$t('KYG021001.label.placeholder_net_weight')"
                  maxlength="7"
                  @input="isActiveNetWeight = false"
                  @blur="isActiveNetWeight = true"
                  v-model="$v.packageModel.netWeight.$model"
                  fix-decimal="1"
                  :class="{
                    'form-error-01':
                      $v.packageModel.netWeight.$error ||
                      errors.get(keyParams.netWeight)
                  }"
                >
                </input-format-number>
                <span class="unit">{{ dataInit.weightUnidCd }}</span>
              </label>
            </li>
          </ul>
        </div>
        <error-message
          :validate="$v.packageModel.netWeight"
          :value="packageModel.netWeight"
          :error="errors.get(keyParams.netWeight)"
          :itemName="$t('KYG021001.label.net_weight_label')"
          :overSizeLabel="
            serviceKbn === '01'
              ? $t('ParamMessage.OverSizeLabel01')
              : $t('ParamMessage.OverSizeLabel03')
          "
        ></error-message>
      </fieldset>

      <fieldset class="form-fieldset-01" v-if="displayNonDocumentItem">
        <legend>
          <label for="select-03-01" class="flex">
            {{ $t("KYG021001.label.paid_free") }}
            <strong class="required-01">{{
              $t("KYG021001.label.required")
            }}</strong></label
          >
        </legend>
        <div class="inner">
          <p>
            <span class="form-select-01 is-large">
              <select
                id="select-03-01"
                v-model="$v.packageModel.paidDiv.$model"
                :class="{
                  'form-error-01':
                    $v.packageModel.paidDiv.$error ||
                    errors.get(keyParams.paidDiv)
                }"
              >
                <option :value="null" disabled>{{
                  $t("Common.option_choose")
                }}</option>
                <option
                  v-for="typePay in dataInit.listTypeOfPay"
                  :key="typePay.sbtNaiID"
                  :value="typePay.sbtNaiID"
                >
                  {{ typePay.stringValue }}
                </option>
              </select>
            </span>
          </p>
        </div>
        <error-message
          :validate="$v.packageModel.paidDiv"
          :isSelectItem="true"
          :value="packageModel.paidDiv"
          :error="errors.get(keyParams.paidDiv)"
          :itemName="$t('KYG021001.label.paid_free')"
        ></error-message>
      </fieldset>

      <fieldset class="form-fieldset-01">
        <legend>
          <label class="flex">{{ $t("KYG021001.label.currency") }}</label>
        </legend>
        <div class="inner">
          <ul class="form-list-01">
            <li>
              <label class="form-input-01">
                <input
                  type="text"
                  placeholder=" "
                  class="disabled"
                  disabled
                /><span class="unit">{{ dataInit.currencyCd }}</span></label
              >
            </li>
          </ul>
        </div>
        <error-message
          :validate="$v.packageModel.currencyCd"
          :value="packageModel.currencyCd"
          :error="errors.get(keyParams.currencyCd)"
          :itemName="$t('KYG021001.label.currency')"
        ></error-message>
      </fieldset>

      <fieldset class="form-fieldset-01" v-if="displayNonDocumentItem">
        <legend>
          <label class="flex">{{ $t("KYG021001.label.quoted_price") }}</label>
        </legend>
        <div class="inner">
          <ul class="form-list-01">
            <li>
              <label class="form-input-01">
                <input
                  type="text"
                  placeholder=" "
                  class="disabled"
                  disabled
                /><span class="unit">{{ dataInit.shipmentTerm }}</span></label
              >
            </li>
          </ul>
        </div>
        <error-message
          :validate="$v.packageModel.shipmentTerm"
          :value="packageModel.shipmentTerm"
          :error="errors.get(keyParams.shipmentTerm)"
          :itemName="$t('KYG021001.label.quoted_price')"
        ></error-message>
      </fieldset>

      <fieldset class="form-fieldset-01" v-if="displayNonDocumentItem">
        <legend class="flex">
          {{ $t("KYG021001.label.length") }}
        </legend>
        <div class="inner">
          <ul class="form-list-01">
            <li>
              <label class="form-input-01">
                <input-format-number
                  :placeholder="$t('KYG021001.label.placeholder_length')"
                  maxlength="5"
                  @input="isActiveLength = false"
                  @blur="isActiveLength = true"
                  v-model="$v.packageModel.length.$model"
                  fix-decimal="1"
                  :class="{
                    'form-error-01':
                      $v.packageModel.length.$error ||
                      errors.get(keyParams.length)
                  }"
                >
                </input-format-number>
                <span class="unit">
                  {{ dataInit.lengthUnidCd }}
                </span>
              </label>
            </li>
          </ul>
        </div>
        <error-message
          :validate="$v.packageModel.length"
          :value="packageModel.length"
          :error="errors.get(keyParams.length)"
          :itemName="$t('KYG021001.label.length_label')"
          :overSizeLabel="
            serviceKbn === '01'
              ? $t('ParamMessage.OverSizeLabel01')
              : $t('ParamMessage.OverSizeLabel03')
          "
        ></error-message>
      </fieldset>

      <fieldset class="form-fieldset-01" v-if="displayNonDocumentItem">
        <legend class="flex">
          {{ $t("KYG021001.label.width") }}
        </legend>
        <div class="inner">
          <ul class="form-list-01">
            <li>
              <label class="form-input-01">
                <input-format-number
                  :placeholder="$t('KYG021001.label.placeholder_width')"
                  maxlength="5"
                  @input="isActiveWidth = false"
                  @blur="isActiveWidth = true"
                  v-model="$v.packageModel.width.$model"
                  fix-decimal="1"
                  :class="{
                    'form-error-01':
                      $v.packageModel.width.$error ||
                      errors.get(keyParams.width)
                  }"
                >
                </input-format-number>
                <span class="unit">{{ dataInit.lengthUnidCd }}</span>
              </label>
            </li>
          </ul>
        </div>
        <error-message
          :validate="$v.packageModel.width"
          :value="packageModel.width"
          :error="errors.get(keyParams.width)"
          :itemName="$t('KYG021001.label.width_label')"
          :overSizeLabel="
            serviceKbn === '01'
              ? $t('ParamMessage.OverSizeLabel01')
              : $t('ParamMessage.OverSizeLabel03')
          "
        ></error-message>
      </fieldset>

      <fieldset class="form-fieldset-01" v-if="displayNonDocumentItem">
        <legend class="flex">
          {{ $t("KYG021001.label.height") }}
        </legend>
        <div class="inner">
          <ul class="form-list-01">
            <li>
              <label class="form-input-01">
                <input-format-number
                  :placeholder="$t('KYG021001.label.placeholder_height')"
                  maxlength="5"
                  @input="isActiveHeight = false"
                  @blur="isActiveHeight = true"
                  v-model="$v.packageModel.height.$model"
                  fix-decimal="1"
                  :class="{
                    'form-error-01':
                      $v.packageModel.height.$error ||
                      errors.get(keyParams.height)
                  }"
                >
                </input-format-number>
                <span class="unit">{{ dataInit.lengthUnidCd }}</span>
              </label>
            </li>
          </ul>
        </div>
        <error-message
          :validate="$v.packageModel.height"
          :value="packageModel.height"
          :error="errors.get(keyParams.height)"
          :itemName="$t('KYG021001.label.height_label')"
          :overSizeLabel="
            serviceKbn === '01'
              ? $t('ParamMessage.OverSizeLabel01')
              : $t('ParamMessage.OverSizeLabel03')
          "
        ></error-message>
      </fieldset>

      <fieldset class="form-fieldset-01" v-if="serviceKbn === '03'">
        <legend class="flex">
          {{ $t("KYG021001.label.cool_category") }}
          <strong class="required-01">{{
            $t("KYG021001.label.required")
          }}</strong>
        </legend>
        <div class="inner">
          <ul class="form-radio-01">
            <li v-for="cool in dataInit.listCool" :key="cool.sbtNaiID">
              <label>
                <input
                  type="radio"
                  name="coolKbn"
                  v-model="$v.packageModel.coolKbn.$model"
                  :value="cool.sbtNaiID"
                  :class="{
                    'form-error-01':
                      $v.packageModel.coolKbn.$error ||
                      errors.get(keyParams.coolDiv)
                  }"
                />
                <span>{{ cool.stringValue }}</span>
              </label>
            </li>
            <!-- /.form-radio-01 -->
          </ul>
        </div>
        <error-message
          :validate="$v.packageModel.coolKbn"
          :value="packageModel.coolKbn"
          :error="errors.get(keyParams.coolDiv)"
          :itemName="$t('KYG021001.label.cool_category')"
        ></error-message>
      </fieldset>

      <fieldset class="form-fieldset-01">
        <legend>
          <label for="textarea-03-01" class="flex">
            {{ $t("KYG021001.label.note") }}
          </label>
        </legend>
        <div class="inner">
          <div class="form-input-02 long-01">
            <span class="input long-01">
              <input
                type="text"
                v-model="$v.packageModel.note1.$model"
                placeholder=" "
                maxlength="35"
                id="textarea-03-01"
                :class="{
                  'form-error-01':
                    $v.packageModel.note1.$error || errors.get(keyParams.note1)
                }"
            /></span>
          </div>
          <error-message
            :validate="$v.packageModel.note1"
            :value="packageModel.note1"
            :error="errors.get(keyParams.note1)"
            :itemName="$t('KYG021001.label.note1')"
            max-digit="35"
          ></error-message>
          <div class="form-input-02 long-01 mt-01">
            <span class="input long-01"
              ><input
                type="text"
                v-model="$v.packageModel.note2.$model"
                placeholder=" "
                maxlength="35"
                id="textarea-03-02"
                :class="{
                  'form-error-01':
                    $v.packageModel.note2.$error || errors.get(keyParams.note2)
                }"
            /></span>
          </div>
          <error-message
            :validate="$v.packageModel.note2"
            :error="errors.get(keyParams.note2)"
            :value="packageModel.note2"
            :itemName="$t('KYG021001.label.note2')"
            max-digit="35"
          ></error-message>
        </div>
      </fieldset>

      <h4 class="hdg-page-04">
        <span>{{ $t("KYG021001.label.payment_method") }}</span>
      </h4>
      <fieldset class="form-fieldset-01">
        <legend class="flex">
          {{ $t("KYG021001.label.pay_custom_fees_method") }}
          <strong class="required-01">{{
            $t("KYG021001.label.required")
          }}</strong>
        </legend>
        <div class="inner">
          <ul class="form-radio-01">
            <li v-for="payment in dataInit.listPayment" :key="payment.sbtNaiID">
              <label>
                <input
                  type="radio"
                  name="paymentDiv"
                  v-model="$v.packageModel.paymentDiv.$model"
                  :value="payment.sbtNaiID"
                  :class="{
                    'form-error-01':
                      $v.packageModel.paymentDiv.$error ||
                      errors.get(keyParams.paymentDiv)
                  }"
                  :disabled="payment.sbtNaiID === '3' && shipmentDiv === 'D'"
                />
                <span>{{ payment.stringValue }}</span>
              </label>
            </li>
            <!-- /.form-radio-01 -->
          </ul>
        </div>
        <error-message
          :validate="$v.packageModel.paymentDiv"
          :value="packageModel.paymentDiv"
          :error="errors.get(keyParams.paymentDiv)"
          :itemName="$t('KYG021001.label.pay_custom_fees_method')"
        ></error-message>
      </fieldset>

      <!-- IOSS VAT登録者 -->
      <template v-if="isShowVatSetting">
        <h4 class="hdg-page-04">
          <span>{{ this.$t("KYG021001.label.vat_register") }}</span>
        </h4>
        <fieldset class="form-fieldset-01">
          <legend class="flex">
            <span>{{ this.$t("KYG021001.label.vat_register_div") }}</span>
            <strong class="required-01">
              {{ $t("KYG021001.label.required") }}
            </strong>
          </legend>
          <div class="inner">
            <ul
              class="form-radio-01"
              v-bind:class="isShowVatSelectCol3 ? 'col3' : 'col2'"
            >
              <template v-for="vatRegister in listVatInputDiv">
                <li :key="vatRegister.sbtNaiID">
                  <label>
                    <input
                      type="radio"
                      name="vatRegisterDiv"
                      v-model="$v.packageModel.vatRegisterDiv.$model"
                      :value="vatRegister.sbtNaiID"
                      :class="{
                        'form-error-01':
                          $v.packageModel.vatRegisterDiv.$error ||
                          errors.get(keyParams.vatRegisterDiv)
                      }"
                    />
                    <span>{{ vatRegister.stringValue }}</span>
                  </label>
                </li>
              </template>
            </ul>
            <p class="txt-alert-01 link-txt-01" v-show="vatSelectionDetail">
              <strong>
                {{ vatSelectionDetail }}
                <a @click.prevent="showVATSelectionDetail()">
                  {{ $t("KYG021001.label.here") }}
                </a>
              </strong>
            </p>
          </div>
          <error-message
            :validate="$v.packageModel.vatRegisterDiv"
            :value="packageModel.vatRegisterDiv"
            :error="errors.get(keyParams.vatRegisterDiv)"
            :itemName="$t('KYG021001.label.vat_register_div')"
          ></error-message>
        </fieldset>
        <fieldset class="form-fieldset-01" v-if="isShowVatNumber">
          <legend class="flex">
            <span>{{ $t("KYG021001.label.vat_register_number") }}</span>
            <strong class="required-01">
              {{ $t("KYG021001.label.required") }}
            </strong>
          </legend>
          <div class="inner">
            <ul class="form-list-01">
              <li>
                <label class="form-input-01">
                  <input
                    type="text"
                    v-model="$v.packageModel.vatRegisterNumber.$model"
                    :placeholder="vatInputPlaceholder"
                    maxlength="35"
                    :class="{
                      'form-error-01':
                        ($v.packageModel.vatRegisterNumber.$error &&
                          vatRegistNumberIsReady) ||
                        errors.get(keyParams.vatRegisterNumber) ||
                        errorUps.get(keyParams.vatRegisterNumber)
                    }"
                  />
                </label>
              </li>
            </ul>
          </div>
          <error-message
            v-if="vatRegistNumberIsReady"
            :validate="$v.packageModel.vatRegisterNumber"
            :value="packageModel.vatRegisterNumber"
            :error="
              errors.get(keyParams.vatRegisterNumber) ||
                errorUps.get(keyParams.vatRegisterNumber)
            "
            :itemName="$t('KYG021001.label.vat_register_number')"
            max-digit="35"
          ></error-message>
        </fieldset>
      </template>

      <!-- インボイス発行 -->
      <template v-if="shipmentDiv">
        <h4 class="hdg-page-04">
          <span>{{ $t("KYG021001.label.invoice") }}</span>
        </h4>
        <fieldset class="form-fieldset-01">
          <legend class="flex">
            {{ $t("KYG021001.label.invoice_create") }}
            <strong class="required-01">{{
              $t("KYG021001.label.required")
            }}</strong>
          </legend>
          <div class="inner">
            <ul class="form-radio-01">
              <li
                v-for="invoiceOutDiv in listInvoiceOutDiv"
                :key="invoiceOutDiv.sbtNaiID"
              >
                <label>
                  <input
                    type="radio"
                    name="invoiceOutDiv"
                    v-model="$v.packageModel.invoiceOutDiv.$model"
                    :value="invoiceOutDiv.sbtNaiID"
                    :class="{
                      'form-error-01':
                        $v.packageModel.invoiceOutDiv.$error ||
                        errors.get(keyParams.invoiceOutDiv)
                    }"
                  />
                  <span>{{ invoiceOutDiv.stringValue }}</span>
                </label>
              </li>
              <!-- /.form-radio-01 -->
            </ul>
            <p class="txt-alert-01 link-txt-01" v-if="!displayNonDocumentItem">
              <strong>
                {{
                  $t("KYG021001.label.please_unnecessary_invoice_for_documents")
                }}
              </strong>
            </p>
          </div>
          <error-message
            :validate="$v.packageModel.invoiceOutDiv"
            :value="packageModel.invoiceOutDiv"
            :error="errors.get(keyParams.invoiceOutDiv)"
            :itemName="$t('KYG021001.label.invoice_create')"
            max-digit="2"
          ></error-message>
        </fieldset>
      </template>
      <h3 class="hdg-page-03" v-show="packageModel.invoiceOutDiv">
        <span>{{ $t("KYG021001.label.hinmoku_setting") }}
              <a class="txt-question-01 link-txt-01" @click.prevent="showHinmokuSetting"></a>
        </span>
      </h3>

      <template v-if="issueInvoiceFlg">
        <p class="txt-alert-01 link-txt-01">
          <strong>
            {{ $t("KYG021001.label.please_enter_all_of_package_info") }}
          </strong>
        </p>

        <div
          class="box-error-01"
          v-if="listErrorMessageItems && listErrorMessageItems.length > 0"
        >
          <ul>
            <li v-for="(item, index) in listErrorMessageItems" :key="index">
              <error-message :error="item"></error-message>
            </li>
          </ul>
        </div>


        <div
          class="box-error-01"
          v-if="errors.get('itemInfo') || (errorUps && errorUps.get('itemInfo'))"
        >
          <ul>
            <li>
              <error-message
                :error="errors.get('itemInfo') || (errorUps && errorUps.get('itemInfo'))"
              ></error-message>
            </li>
          </ul>
        </div>
        <div id="table-list-item" class="box-scroll-02 tbl-scroll-02">
          <table class="tbl-data-01 js-tbl-width-01">
            <thead>
              <tr>
                <th class="w-01">
                  {{ $t("KYG021001.label.no_with_dot") }}
                </th>
                <th class="w-2">
                  {{ $t("KYG021001.label.header_reference") }}
                </th>
                <th class="w-4">
                  {{ $t("KYG021001.label.header_item_code") }}
                </th>
                <th class="w-5">
                  {{ $t("KYG021001.label.header_item_name") }}
                </th>
                <th class="w-6">
                  {{ $t("KYG021001.label.header_hs_code") }}
                </th>
                <th class="w-5">
                  {{ $t("KYG021001.label.header_origin_country") }}
                </th>
                <th class="w-4">
                  {{ $t("KYG021001.label.header_unit_price") }}
                </th>
                <th class="w-4">
                  {{ $t("KYG021001.label.header_unit") }}
                </th>
                <th class="w-4">
                  {{ $t("KYG021001.label.header_quantity") }}
                </th>
                <th class="w-4">
                  {{ $t("KYG021001.label.header_total") }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in packageModel.listItems" :key="index">
                <td class="w-01">{{ item.no }}</td>
                <td class="w-2">
                  <button
                    type="button"
                    class="tbl-clear-01"
                    @click="deleteItem(index)"
                  >
                    {{ $t("KYG021001.label.delete") }}
                  </button>
                </td>
                <td class="w-4">
                  <label class="form-input-03">
                    <input
                      type="text"
                      maxlength="16"
                      :placeholder="$t('KYG021001.label.placeholder_hincode')"
                      v-model="item.itemCd"
                      :class="{
                        itemtableerror:
                          arrItemError.get('itemInfo[' + index + '].itemCd') ||
                          errors.get('itemInfo[' + index + '].itemCd')
                      }"
                  /></label>
                </td>
                <td class="w-5">
                  <label class="form-input-03">
                    <input
                      type="text"
                      maxlength="105"
                      :placeholder="$t('KYG021001.label.placeholder_hinname')"
                      v-model="item.itemName"
                      @change="updateListPresent()"
                      :class="{
                        itemtableerror:
                          arrItemError.get(
                            'itemInfo[' + index + '].itemName'
                          ) || errors.get('itemInfo[' + index + '].itemName')
                      }"
                  /></label>
                </td>
                <td class="w-6">
                  <label class="form-input-03">
                    <input
                      type="text"
                      maxlength="15"
                      :placeholder="$t('KYG021001.label.placeholder_hs')"
                      v-model="item.hsCd"
                      @change="item.hsCd = trimValue(item.hsCd)"
                      :class="{
                        itemtableerror:
                          arrItemError.get('itemInfo[' + index + '].hsCd') ||
                          errors.get('itemInfo[' + index + '].hsCd')
                      }"
                  /></label>
                </td>
                <td class="w-5">
                  <span class="form-select-01 is-small">
                    <select
                      v-model="item.originCountryId"
                      @change="
                        getOriginCountryName(item.originCountryId, index)
                      "
                      :class="{
                        itemtableerror:
                          arrItemError.get(
                            'itemInfo[' + index + '].originCountryId'
                          ) ||
                          errors.get('itemInfo[' + index + '].originCountryId')
                      }"
                    >
                      <option :value="null" disabled>{{
                        $t("Common.option_choose")
                      }}</option>
                      <option
                        v-for="country in dataInit.listOriginCountry"
                        :key="country.originCountryId"
                        :value="country.originCountryId"
                        >{{ country.originCountryName }}</option
                      >
                    </select>
                    <input
                      type="text"
                      hidden
                      v-model="item.originCountryName"
                    />
                  </span>
                </td>
                <td class="w-4">
                  <label class="form-input-03">
                    <input-format-number
                      :placeholder="
                        $t('KYG021001.label.placeholder_unit_price')
                      "
                      maxlength="10"
                      v-model="item.valueOfUnit"
                      class="ta-r"
                      :class="{
                        itemtableerror:
                          arrItemError.get(
                            'itemInfo[' + index + '].valueOfUnit'
                          ) || errors.get('itemInfo[' + index + '].valueOfUnit')
                      }"
                    >
                    </input-format-number>
                  </label>
                </td>
                <td class="w-4">
                  <span class="form-select-01 is-small">
                    <select
                      v-model="item.unitCd"
                      @change="getUnitName(item.unitCd.$model, index)"
                      :class="{
                        itemtableerror:
                          arrItemError.get('itemInfo[' + index + '].unitCd') ||
                          errors.get('itemInfo[' + index + '].unitCd')
                      }"
                    >
                      <option :value="null" disabled>{{
                        $t("Common.option_choose")
                      }}</option>
                      <option
                        v-for="unit in dataInit.listUnit"
                        :key="unit.unitCd"
                        :value="unit.unitCd"
                        >{{ unit.unitName }}</option
                      >
                    </select>
                    <input type="text" hidden v-model="item.unitName" />
                  </span>
                </td>
                <td class="w-4">
                  <label class="form-input-03">
                    <input-format-number
                      :placeholder="$t('KYG021001.label.placeholder_quantity')"
                      maxlength="4"
                      v-model="item.quantity"
                      class="ta-r"
                      :class="{
                        itemtableerror:
                          arrItemError.get(
                            'itemInfo[' + index + '].quantity'
                          ) || errors.get('itemInfo[' + index + '].quantity')
                      }"
                    >
                    </input-format-number>
                  </label>
                </td>
                <td class="w-4 ta-r">
                  {{
                    (item.total = calculateItemTotal(
                      item.quantity,
                      item.valueOfUnit
                    ))
                  }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <ul class="btn-list-01">
          <li>
            <p class="link-btn-04 search ta-c mb-00">
              <a class="js-modal-01" @click.prevent="openDialogSearchItem()">
                <span>{{ $t("KYG021001.label.search_item") }}</span>
              </a>
            </p>
          </li>
          <li>
            <p class="link-btn-04 add ta-c mb-00">
              <button type="button" @click="addRecord()">
                <span>{{ $t("KYG021001.label.add_record") }}</span>
              </button>
            </p>
          </li>
        </ul>
        <b-modal
          id="searchItemDialog"
          hide-header
          hide-footer
          no-close-on-esc
          no-close-on-backdrop
          no-fade
        >
          <search-item-dialog
            :itemSearchParam="itemSearchParam"
            @addItems="addListItems"
            @closeModal="closeModalSearchItem"
          ></search-item-dialog>
        </b-modal>
      </template>

      <fieldset class="form-fieldset-01" v-show="packageModel.invoiceOutDiv">
        <legend>
          <label for="select-03-04" class="flex">
            {{ $t("KYG021001.label.representative_item_name") }}
            <strong class="required-01">{{
              $t("KYG021001.label.required")
            }}</strong></label
          >
        </legend>
        <div class="inner">
          <p class="mb-01" v-if="issueInvoiceFlg">
            <!-- 品目.代表品目名1 -->
            <span class="form-select-01 is-large-02">
              <select
                id="select-03-04"
                v-model="packageModel.rePresent"
                class="max-width-represent-item2"
                :class="{
                  'form-error-01':
                    ($v.packageModel.rePresent.$error && rePresentIsReady) ||
                    errors.get(keyParams.representativeItemName)
                }"
              >
                <option :value="null" disabled>{{
                  $t("Common.option_choose")
                }}</option>
                <option
                  v-for="item in listRePresents"
                  :key="item.key"
                  :value="item.name"
                >
                  {{ item.key }}</option
                >
              </select>
            </span>
          </p>
          <!-- 品目.代表品目名2 -->
          <ul class="form-list-02" v-else>
            <li>
              <label class="form-input-01">
                <input
                  type="text"
                  id="rePresentInput"
                  :placeholder="$t('KYG021001.label.placeholder_hinname')"
                  maxlength="105"
                  v-model="$v.packageModel.rePresent.$model"
                  :class="{
                    'form-error-01':
                      ($v.packageModel.rePresent.$error && rePresentIsReady) ||
                      errors.get(keyParams.representativeItemName)
                  }"
                />
              </label>
            </li>
          </ul>
          <p class="txt-alert-01 link-txt-01">
            <strong>{{
              issueInvoiceFlg
                ? $t("KYG021001.label.representative_item_guide")
                : $t("KYG021001.label.representative_item_guide_free")
            }}</strong>
          </p>
        </div>
        <error-message
          v-if="rePresentIsReady"
          :validate="$v.packageModel.rePresent"
          :isSelectItem="issueInvoiceFlg"
          :value="packageModel.rePresent"
          :error="errors.get(keyParams.representativeItemName)"
          :itemName="$t('KYG021001.label.representative_item_name')"
          max-digit="105"
        ></error-message>
      </fieldset>

      <div
        class="box-01"
        v-if="
          packageModel.invoiceOutDiv &&
            (issueInvoiceFlg || (!issueInvoiceFlg && displayNonDocumentItem))
        "
      >
        <fieldset class="form-fieldset-01 mb-00">
          <legend>
            <label for="input-03-05" class="flex">
              {{ $t("KYG021001.label.total_product_price") }}
              <strong
                class="required-01"
                v-show="!issueInvoiceFlg && displayNonDocumentItem"
              >
                {{ $t("KYG021001.label.required") }}
              </strong>
            </label>
          </legend>
          <div class="inner">
            <div class="form-input-02">
              <span class="input fs-02"
                ><input
                  v-show="issueInvoiceFlg"
                  type="text"
                  placeholder=" "
                  class="ta-r disabled"
                  disabled
                  id="input-03-05"
                  v-model="packageModel.totalProductPrice"
                />
                <input-format-number
                  v-show="!issueInvoiceFlg && displayNonDocumentItem"
                  :placeholder="
                    $t('KYG021001.label.placeholder_total_product_price')
                  "
                  maxlength="10"
                  v-model="$v.packageModel.totalProductPrice.$model"
                  :class="{
                    'form-error-01':
                      ($v.packageModel.totalProductPrice.$error &&
                        totalProductPriceIsReady) ||
                      errors.get(keyParams.itemTotal)
                  }"
                >
                </input-format-number>
              </span>
              <span class="txt">{{ dataInit.currencyCd }}</span>
            </div>
          </div>
          <error-message
            v-if="totalProductPriceIsReady"
            :validate="$v.packageModel.totalProductPrice"
            :value="packageModel.totalProductPrice"
            :error="errors.get(keyParams.itemTotal)"
            :itemName="$t('KYG021001.label.total_product_price')"
            msg-not-null="1"
          ></error-message>
        </fieldset>
      </div>

      <div class="box-02">
        <p class="mb-01">
          {{
            issueInvoiceFlg
              ? $t("KYG021001.label.master_regist_guide")
              : $t("KYG021001.label.master_regist_guide_no_item")
          }}
        </p>

        <ul class="form-checkbox-02">
          <li>
            <label>
              <input
                v-model="packageModel.registerAll"
                type="checkbox"
                @change="registerAllChange"
                id="js-check-01"
                name="register"
              />
              <span>{{
                issueInvoiceFlg
                  ? $t("KYG021001.label.checkbox_selection_guide")
                  : $t("KYG021001.label.checkbox_selection_guide_no_item")
              }}</span>
            </label>
            <ul :class="issueInvoiceFlg ? 'inner' : 'inner-no-item'">
              <li>
                <label
                  ><input
                    type="checkbox"
                    v-model="packageModel.registerAddressee"
                    class="js-check-01"
                    name="register"
                  />
                  <span>{{
                    $t("KYG021001.label.register_addressee")
                  }}</span></label
                >
              </li>
              <li>
                <label
                  ><input
                    type="checkbox"
                    v-model="packageModel.registerClient"
                    class="js-check-01"
                    name="register"
                  />
                  <span>{{
                    $t("KYG021001.label.register_client")
                  }}</span></label
                >
              </li>
              <li v-if="issueInvoiceFlg">
                <label
                  ><input
                    type="checkbox"
                    v-model="packageModel.registerItem"
                    class="js-check-01"
                    name="register"
                  /><span>{{
                    $t("KYG021001.label.register_item")
                  }}</span></label
                >
              </li>
            </ul>
          </li>
        </ul>
      </div>

      <div class="flex-box type1">
        <p class="ta-r link-btn-clear-01">
          <button type="button" class="js-clear-btn" @click="clearForm()">
            <span>{{ $t("KYG021001.label.clear_input_items") }}</span>
          </button>
        </p>
        <p class="link-btn-02 is-large ta-c">
          <button
            type="button"
            class="js-toggle-error"
            @click="checkPrintContent"
          >
            <span>{{ $t("KYG021001.label.go_to_check_print_contents") }}</span>
          </button>
        </p>
      </div>
      <!-- / .js-toggle-content-01 -->
    </div>

    <!-- / .js-toggle-item-01 -->
  </div>
</template>

<script>
import InputFormatNumber from "@/components/InputFormatNumber";
import { minLength, maxLength, required } from "vuelidate/lib/validators";
import CommonService from "@/core/utils/common-service";
import { CONSTANTS } from "@/constants/common-constant";
import url from "@/constants/url-const";

const delText = "KYG021001.label.delete";
const item = "品目";
const item_limit = "50";
const emptyItem = {
  no: "1",
  del: null,
  itemCd: "",
  itemName: "",
  hsCd: "",
  originCountryId: null,
  originCountryName: null,
  valueOfUnit: "",
  unitCd: null,
  unitName: null,
  quantity: "",
  total: null
};
const checkDecimal4Digit = value => CommonService.checkDecimal4Digit(value);
const checkDecimal6Digit = value => CommonService.checkDecimal6Digit(value);
const zeroError = value => CommonService.checkZeroError(value);
const checkDecimal = CommonService.checkDecimal();

const dummyItem = {
  itemCd: "*",
  itemName: "*",
  hsCd: "",
  originCountryId: "JP",
  valueOfUnit: "1",
  unitCd: "EA",
  quantity: "1"
};

// インボイス発行の区分
const INVOICE_OUT_DIV = {
  // 発行する
  ISSUE_INVOICE: "01",
  // 発行しない
  DO_NOT_ISSUE_INVOICE: "02"
};

// 品目.代表品目名2
// 貨物種別「書類」を選択した場合、初期値は「DOCUMENT」とする。
const REPRESENTATIVE_ITEM_NAME_DOCUMENT = "DOCUMENT";

const NON_DOCUMENT = "N";

export default {
  data() {
    return {
      isLoadingScreen: false,
      expander: true,
      weightMinValue: 0.1,
      quantityMinValue: 0.1,
      grossWeightIsReady: false,
      rePresentIsReady: false,
      vatRegistNumberIsReady: false,
      totalProductPriceIsReady: false,

      packageModel: {
        listItems: [{ ...emptyItem, del: this.$t(delText) }],

        paidDiv: null,
        rePresent: null,
        grossWeight: null,
        netWeight: null,
        shipmentTerm: null,
        length: null,
        width: null,
        height: null,
        coolKbn: null,
        coolOfferKbn: null,
        note1: null,
        note2: null,
        paymentDiv: null,
        vatRegisterDiv: null,
        vatRegisterNumber: null,
        invoiceOutDiv: null,
        totalProductPrice: "0",
        registerAll: false,
        registerAddressee: false,
        registerClient: false,
        registerItem: false
      },

      itemSearchParam: null,
      coolFlag: false,
      bulkFlag: false,
      authorizedFlag: false,
      invalidInput: false,
      itemSettingInvalid: true,
      cityDisplay: false,
      overWriteConfirmFlag: false,
      isAddNewItem: false,
      listRePresents: [],
      listErrorMessageItems: null,
      arrItemError: new Map(),
      isActiveGrossWeight: true,
      isActiveNetWeight: true,
      isActiveHeight: true,
      isActiveWidth: true,
      isActiveLength: true,
      errorUps: new Map()
    };
  },
  props: {
    errors: {
      type: Map,
      default: function() {
        return new Map();
      }
    },
    shipmentDiv: String,
    serviceKbn: String,
    isShowPackage: Boolean,
    keyParams: Object,
    isValidateBasicShipper: Boolean,
    countryCd: String,
    dataInit: {
      listTypeOfPay: { type: Array, default: [] },
      listUnit: { type: Array, default: [] },
      listPayment: { type: Array, default: [] },
      listCool: { type: Array, default: [] },
      listOriginCountry: { type: Array, default: [] },
      listSizeLimit: { type: Array, default: [] },
      listWeightLimit: { type: Array, default: [] },
      listRePresentItemName: { type: Array, default: [] },
      listInvoiceByDocument: { type: Array, default: [] },
      listInvoiceByNonDocument: { type: Array, default: [] },
      listVatRegisterDiv: { type: Array, default: [] },
      listVatRegisterNotice: { type: Array, default: [] },
      listVatRegisterHint: { type: Array, default: [] },
      listVatRegisterCountry: { type: Array, default: [] },
      currencyCd: { type: String, default: null },
      lengthUnidCd: { type: String, default: null },
      weightUnidCd: { type: String, default: null },
      shipmentTerm: { type: String, default: null }
    }
  },
  updated() {
    this.$nextTick(function() {
      if (this.isAddNewItem) {
        // テーブルの最下部にスクロールする
        const tableElement = this.$el.querySelector("#table-list-item tbody");
        if (tableElement) {
          tableElement.scrollTop = tableElement.scrollHeight;
          this.isAddNewItem = false;
        }
      }
    });

    CommonService.freezeTable("table-list-item");
  },
  watch: {
    serviceKbn() {
      if (this.serviceKbn !== "03") {
        this.$v.packageModel.coolKbn.$reset();
        this.packageModel.coolKbn = null;
      }
    },
    packageModel: {
      handler: function(val, oldVal) {
        //IEのカスタム検証
        this.setValidationReady("0");

        this.$emit("packageInfoModelChange", {
          newValue: val,
          oldVal: oldVal
        });
      },
      deep: true
    },
    "packageModel.listItems": {
      handler: function(newVal) {
        if (!this.issueInvoiceFlg) {
          return;
        }
        const tmpList = newVal.map(item => {
          return item.quantity * item.valueOfUnit;
        });
        let total =
          tmpList.length > 0
            ? tmpList.reduce(function(a, b) {
                return Number(a) + Number(b);
              })
            : 0;
        total = CommonService.formatNumber(total);

        if (!total) {
          this.packageModel.totalProductPrice = "0";
        } else {
          this.packageModel.totalProductPrice = total !== 0 ? total : "0";
        }
        if (this.packageModel.totalProductPrice) {
          this.$v.packageModel.totalProductPrice.$touch();
        } else {
          this.$v.packageModel.totalProductPrice.$reset();
        }
      },
      deep: true
    },
    changeRegistData() {
      this.packageModel.registerAll = this.changeRegistData;
    },
    "packageModel.rePresent": {
      handler: function(newVal) {
        if (newVal === "") {
          this.packageModel.rePresent = null;
        }
      },
      deep: true
    },
    isShowPackage() {
      if (this.isShowPackage) {
        let existError = false;
        Object.keys(this.keyParams).forEach(key => {
          if (this.errors.has(key) || this.errorUps.has(key)) {
            existError = true;
            return;
          }
        });
        if (!existError) {
          this.invalidInput = false;
        }
      }
    }
  },
  components: {
    ErrorMessage: () => import("@/components/ErrorMessage"),
    SearchItemDialog: () => import("@/modules/searchItem/pages/SearchItem"),
    InputFormatNumber
  },
  validations() {
    const checkPaidDivRequired = value =>
      CommonService.checkPaidDivRequired(value, this.shipmentDiv);

    const checkPaidDivValue = value => CommonService.checkPaidDivValue(value);

    const checkTotalPrice = value =>
      CommonService.check10Digit(
        value ? parseFloat(value.toString().replace(/[^\d.]/g, "")) : value
      );

    const checkCharCtrl01 = value => CommonService.checkCharCtrl01(value);
    const checkCharCtrl02 = value => CommonService.checkCharCtrl02(value);

    const fieldLengthCheck = param => value =>
      CommonService.fieldLengthCheck(value, param);

    const itemNameCheck = value =>
      CommonService.itemNameCheck(value, this.packageModel.listItems);

    const halfNumberic = value => CommonService.checkHalfNumberic(value);

    const halfAlphaNumberic = value => CommonService.halfAlphaNumberic(value);

    const checkDupplicate = value =>
      CommonService.checkDupplicate(value, this.packageModel.listItems);

    const checkCool = value => CommonService.checkCool(value, this.serviceKbn);

    const checkCoolKbnValue = value => CommonService.checkCoolKbnValue(value);

    return {
      packageModel: {
        height: this.validationHeight,
        width: this.validationWidth,
        length: this.validationLength,
        grossWeight: this.validationGrossWeight,
        netWeight: this.validationNetWeight,
        paidDiv: {
          checkPaidDivRequired,
          checkPaidDivValue
        },
        currencyCd: {},
        rePresent: this.issueInvoiceFlg
          ? {
              required,
              fieldLengthCheck: fieldLengthCheck(105),
              checkCharCtrl02,
              itemNameCheck
            }
          : {
              required,
              fieldLengthCheck: fieldLengthCheck(105),
              checkCharCtrl02
            },
        note1: {
          fieldLengthCheck: fieldLengthCheck(35),
          checkCharCtrl01
        },
        note2: {
          fieldLengthCheck: fieldLengthCheck(35),
          checkCharCtrl01
        },
        coolKbn: {
          fieldLengthCheck: fieldLengthCheck(1),
          halfNumberic,
          checkCool,
          checkCoolKbnValue
        },
        shipmentTerm: {},
        paymentDiv: {
          required
        },
        vatRegisterDiv: this.isShowVatSetting
          ? { required, fieldLengthCheck: fieldLengthCheck(2), halfNumberic }
          : {},
        vatRegisterNumber:
          this.packageModel.vatRegisterDiv &&
          this.packageModel.vatRegisterDiv !==
            CONSTANTS.VAT_REGISTER_DIV_NOT_REGIST
            ? {
                required,
                fieldLengthCheck: fieldLengthCheck(35),
                checkCharCtrl01
              }
            : {},
        invoiceOutDiv: {
          required,
          fieldLengthCheck: fieldLengthCheck(2),
          halfNumberic
        },
        totalProductPrice:
          !this.issueInvoiceFlg && this.displayNonDocumentItem
            ? {
                required,
                checkTotalPrice,
                fieldLengthCheck: fieldLengthCheck(10),
                halfNumberic,
                zeroError
              }
            : {
                required,
                checkTotalPrice
              },
        listItems: {
          $each: {
            no: {},
            itemCd: {
              required,
              fieldLengthCheck: fieldLengthCheck(16),
              checkCharCtrl01,
              checkDupplicate
            },
            itemName: {
              required,
              fieldLengthCheck: fieldLengthCheck(105),
              checkCharCtrl02
            },
            hsCd: {
              minLength: minLength(6),
              maxLength: maxLength(15),
              checkCharCtrl01
            },
            originCountryId: {
              required,
              fieldLengthCheck: fieldLengthCheck(3)
            },
            valueOfUnit: {
              required,
              fieldLengthCheck: fieldLengthCheck(10),
              halfNumberic,
              zeroError,
              checkValueTotalMoney: (value, listItems) => {
                return CommonService.checkValueTotalMoney(
                  value,
                  listItems.quantity
                );
              }
            },
            unitCd: {
              required,
              fieldLengthCheck: fieldLengthCheck(3),
              halfAlphaNumberic
            },
            quantity: {
              required,
              fieldLengthCheck: fieldLengthCheck(4),
              halfNumberic,
              zeroError,
              checkValueTotalMoney: (value, listItems) => {
                return CommonService.checkValueTotalMoney(
                  value,
                  listItems.valueOfUnit
                );
              }
            },
            total: {},
            $trackBy: "no"
          }
        }
      }
    };
  },
  mounted: function() {
    // 前の画面から取得したデータがある場合、各項目に値を設定する
    if (this.$store.getters.shipment) {
      const shipment = this.$store.getters.shipment;
      // 荷物情報
      if (shipment.packageInfo && shipment.packageInfo.length > 0) {
        const packageInfo = shipment.packageInfo[0];
        this.packageModel.grossWeight = packageInfo.grossWeight
          ? packageInfo.grossWeight
          : null;
        this.packageModel.netWeight = packageInfo.netWeight
          ? packageInfo.netWeight
          : null;
        this.packageModel.paidDiv = packageInfo.paidDiv
          ? packageInfo.paidDiv
          : null;
        this.packageModel.length = packageInfo.length
          ? packageInfo.length
          : null;
        this.packageModel.width = packageInfo.width ? packageInfo.width : null;
        this.packageModel.height = packageInfo.height
          ? packageInfo.height
          : null;
        this.packageModel.note1 = packageInfo.note1 ? packageInfo.note1 : null;

        this.packageModel.note2 = packageInfo.note2 ? packageInfo.note2 : null;

        this.packageModel.rePresent = packageInfo.representativeItemName
          ? packageInfo.representativeItemName
          : null;

        this.packageModel.totalProductPrice =
          !packageInfo.itemTotal || isNaN(packageInfo.itemTotal)
            ? ""
            : parseInt(packageInfo.itemTotal).toString();

        if (packageInfo.itemInfo) {
          this.packageModel.listItems = packageInfo.itemInfo;
        }
      }

      this.packageModel.paymentDiv = shipment.paymentDiv
        ? shipment.paymentDiv
        : null;

      this.packageModel.invoiceOutDiv = shipment.invoiceOutDiv
        ? shipment.invoiceOutDiv
        : null;

      this.packageModel.vatRegisterDiv = shipment.vatRegisterDiv
        ? shipment.vatRegisterDiv
        : null;

      this.packageModel.vatRegisterNumber = shipment.vatRegisterNumber
        ? shipment.vatRegisterNumber
        : null;

      this.packageModel.coolKbn = shipment.coolDiv ? shipment.coolDiv : null;

      this.updateListPresent();

      this.packageModel.registerAddressee = shipment.registerConsigneeInfoFlg
        ? shipment.registerConsigneeInfoFlg
        : null;

      this.packageModel.registerClient = shipment.registerShipperInfoFlg
        ? shipment.registerShipperInfoFlg
        : null;
      this.packageModel.registerItem = shipment.registerItemInfoFlg
        ? shipment.registerItemInfoFlg
        : null;
      this.errorUps = shipment.errors;
    }
    this.$nextTick(function() {
      this.$watch("shipmentDiv", function(newVal, oldVal) {
        this.changeShipmentDiv(newVal, oldVal);
      });
      this.$watch("packageModel.invoiceOutDiv", function(newVal, oldVal) {
        this.changeInvoiceOutDiv(newVal, oldVal);
      });
      this.$watch("countryCd", function() {
        this.changeCountryCd();
      });
      this.$watch("dataInit.listVatRegisterCountry", function() {
        if (this.countryCd && !this.packageModel.vatRegisterDiv) {
          this.changeCountryCd();
        }
      });
      this.$watch("packageModel.vatRegisterDiv", function() {
        this.changeVatRegisterDiv();
      });
    });
  },
  methods: {
    changeExpander(isShow) {
      if (isShow) {
        this.expander = isShow;
      } else {
        this.expander = !this.expander;
      }
    },
    //「入力項目をクリア」押下時
    clearForm() {
      CommonService.showDialogConfirm(
        this.$bvModal,
        this.$createElement,
        this.$t("Message.clearInput")
      ).then(isClear => {
        if (isClear) {
          this.packageModel.length = null;
          this.packageModel.width = null;
          this.packageModel.height = null;
          this.packageModel.paidDiv = null;
          this.packageModel.grossWeight = null;
          this.grossWeightIsReady = false;
          this.packageModel.netWeight = null;
          this.packageModel.coolKbn = null;
          this.packageModel.coolOfferKbn = null;
          this.packageModel.note1 = null;
          this.packageModel.note2 = null;
          this.packageModel.paymentDiv = null;
          this.packageModel.vatRegisterDiv = null;
          this.packageModel.vatRegisterNumber = null;
          this.vatRegistNumberIsReady = false;
          this.packageModel.invoiceOutDiv = null;
          this.packageModel.rePresent = null;
          this.rePresentIsReady = false;
          this.packageModel.totalProductPrice = null;
          this.totalProductPriceIsReady = false;
          this.packageModel.registerAll = false;
          this.packageModel.registerAddressee = false;
          this.packageModel.registerClient = false;
          this.packageModel.registerItem = false;
          this.invalidInput = false;
          this.listRePresents = [];
          this.$v.packageModel.$reset();
          Object.keys(this.keyParams).forEach(key => {
            this.errors.delete(key);
            this.errorUps.delete(key);
          });
          CommonService.removeKeyStartsWith(this.errors, "itemInfo[");
          this.packageModel.listItems = [
            { ...emptyItem, del: this.$t(delText) }
          ];
          this.getListErrorMessageItems();
          CommonService.scrollToItem("expandPackageInfo");
        }
      });
    },
    //「すべての情報マスタの登録」変更時
    registerAllChange() {
      if (this.packageModel.registerAll) {
        this.packageModel.registerAddressee = true;
        this.packageModel.registerClient = true;
        this.packageModel.registerItem = this.issueInvoiceFlg;
      } else {
        this.packageModel.registerAddressee = false;
        this.packageModel.registerClient = false;
        this.packageModel.registerItem = false;
      }
    },

    //「品目.削除」押下時
    deleteItem(index) {
      const _vm = this.packageModel;
      if (_vm.listItems) {
        if (_vm.listItems.length === 1) {
          _vm.listItems = [{ ...emptyItem, del: this.$t(delText) }];
          this.$v.packageModel.listItems.$each.$reset();
          this.getListErrorMessageItems();
          this.updateListPresent();
          return;
        }
        this.packageModel.listItems.splice(index, 1);
        this.packageModel.listItems.forEach(item => {
          if (index < item.no) {
            item.no -= 1;
          }
        });

        this.$v.packageModel.listItems.$touch();
        this.getListErrorMessageItems();
        this.updateListPresent();
      }
    },
    //add list item to grid
    addListItems(listItem) {
      this.removeEmptyItems();
      this.$v.packageModel.listItems.$touch();
      this.getListErrorMessageItems();
      const currentListItemSize = this.packageModel.listItems.length;
      for (let i = 0; i < listItem.length; i++) {
        const item = {
          no: currentListItemSize + i + 1,
          del: this.$t(delText),
          itemCd: listItem[i].itemCd,
          itemName: listItem[i].itemName,
          hsCd: listItem[i].hsCd,
          originCountryId: this.dataInit.listOriginCountry.find(
            originCountry =>
              originCountry.originCountryId === listItem[i].originCountryId
          )
            ? listItem[i].originCountryId
            : null,
          originCountryName: listItem[i].originCountryName,
          valueOfUnit: listItem[i].valueOfUnit,
          unitCd: this.dataInit.listUnit.find(
            unit => unit.unitCd === listItem[i].unitCd
          )
            ? listItem[i].unitCd
            : null,
          unitName: listItem[i].unitName,
          quantity: ""
        };
        this.packageModel.listItems.push(item);
        this.$v.packageModel.listItems.$each[
          this.packageModel.listItems.length - 1
        ].$reset();
        this.isAddNewItem = true;
      }
      this.updateListPresent();
      this.closeModalSearchItem();
    },
    removeEmptyItems() {
      const _vm = this.packageModel;
      _vm.listItems = _vm.listItems.filter(item => this.isNotEmptyItem(item));
      for (let i = 0; i < _vm.listItems.length; i++) {
        if (_vm.listItems[i].no !== i + 1) {
          _vm.listItems[i].no = i + 1;
        }
      }
    },
    isNotEmptyItem(item) {
      return Object.keys(item).some(function(val) {
        if (val === "no" || val === "del") {
          return false;
        } else {
          return item[val];
        }
      });
    },
    closeModalSearchItem() {
      this.$bvModal.hide("searchItemDialog");
    },
    //「品目を検索」押下時
    openDialogSearchItem() {
      const itemSelectAble = this.packageModel.listItems.filter(item =>
        this.isNotEmptyItem(item)
      ).length;
      if (itemSelectAble >= 50) {
        const messageError = this.$t("Error.business.OverDisplayLimit", {
          0: item,
          1: item_limit
        });
        CommonService.showDialogOk(
          this.$bvModal,
          this.$createElement,
          messageError
        );
      } else {
        this.itemSearchParam = {
          mode: "01",
          upperLimit: "50",
          selectAble: 50 - itemSelectAble
        };
        this.$bvModal.show("searchItemDialog");
      }
    },
    //「レコードを追加」押下時
    addRecord() {
      this.$v.packageModel.listItems.$touch();
      this.getListErrorMessageItems();
      if (this.packageModel.listItems.length >= 50) {
        const messageError = this.$t("Error.business.OverDisplayLimit", {
          0: item,
          1: item_limit
        });
        CommonService.showDialogOk(
          this.$bvModal,
          this.$createElement,
          messageError
        );
      } else {
        this.packageModel.listItems.push({
          ...emptyItem,
          no: this.packageModel.listItems.length + 1,
          del: this.$t(delText)
        });
        this.$v.packageModel.listItems.$each[
          this.packageModel.listItems.length - 1
        ].$reset();
        this.isAddNewItem = true;
      }
    },
    //「印刷内容の確認へ」押下時
    checkPrintContent() {
      //IEのカスタム検証
      this.setValidationReady("1");
      this.$v.$touch();
      this.getListErrorMessageItems();
      this.invalidInput = this.$v.$invalid;
      this.$emit("validateBasicShipper");
      this.$nextTick(function() {
        if (this.isValidateBasicShipper) {
          return;
        }
        if (this.$v.$invalid) {
          CommonService.scrollToItem("expandPackageInfo");
          return;
        }
        this.$emit("checkPrintContent");
      });
    },
    //番号を確認する
    isNumber(value) {
      const patt1 = /^[0-9]*\.[0-9]*$/;
      const patt2 = /^[0-9]*$/;
      if (patt1.test(value) || patt2.test(value)) {
        return true;
      } else {
        return false;
      }
    },
    getOriginCountryName(originCountryId, index) {
      let item = this.dataInit.listOriginCountry.find(obj => {
        return obj.originCountryId === originCountryId;
      });
      if (item) {
        this.packageModel.listItems[index].originCountryName =
          item.originCountryName;
      }
    },
    getUnitName(unitCd, index) {
      let item = this.dataInit.listUnit.find(obj => {
        return obj.unitCd === unitCd;
      });
      if (item) {
        this.packageModel.listItems[index].unitName = item.unitName;
      }
    },
    //IEのカスタム検証
    setValidationReady(type) {
      if (this.packageModel.grossWeight || type === "1") {
        this.grossWeightIsReady = true;
      }

      if (this.packageModel.rePresent || type === "1") {
        this.rePresentIsReady = true;
      }

      if (this.packageModel.totalProductPrice || type === "1") {
        this.totalProductPriceIsReady = true;
      }

      if (this.packageModel.vatRegisterNumber || type === "1") {
        this.vatRegistNumberIsReady = true;
      }
    },
    getListErrorMessageItems() {
      if (
        !this.packageModel.listItems &&
        (!this.errors || this.errors.size === 0)
      ) {
        return null;
      }

      let arrErrorMessage = [];
      this.arrItemError = new Map();

      for (let i = 0; i < this.packageModel.listItems.length; i++) {
        const item = this.$v.packageModel.listItems.$each[i];

        arrErrorMessage = this.checkItemError1(arrErrorMessage, item, i);

        arrErrorMessage = this.checkItemError2(arrErrorMessage, item, i);
      }
      this.listErrorMessageItems = [...new Set(arrErrorMessage)];
    },
    checkItemError1(arrErrorMessage, item, i) {
      const itemCdError = {
        validate: null,
        value: null,
        itemName: this.$t("KYG021001.label.items_code"),
        maxDigit: "16"
      };
      const itemNameError = {
        validate: null,
        value: null,
        itemName: this.$t("KYG021001.label.product_name"),
        maxDigit: "105"
      };
      const hsCdError = {
        validate: null,
        value: null,
        itemName: this.$t("KYG021001.label.hs_code"),
        minValue: "6",
        maxValue: "15"
      };
      const originCountryError = {
        validate: null,
        value: null,
        itemName: this.$t("KYG021001.label.origin_of_country"),
        maxDigit: "3"
      };
      const itemInfo = "itemInfo[";
      const itemCd = "].itemCd";
      const itemName = "].itemName";
      const hsCd = "].hsCd";
      const originCountryId = "].originCountryId";

      if (item.itemCd.$error) {
        itemCdError.validate = item.itemCd;
        itemCdError.value = item.itemCd.$model;
        arrErrorMessage.push(CommonService.getErrorMessage(itemCdError));
        this.arrItemError.set(itemInfo + i + itemCd, true);
      }

      if (this.errors.get(itemInfo + i + itemCd)) {
        arrErrorMessage.push(this.errors.get(itemInfo + i + itemCd));
      }
      if (item.itemName.$error) {
        itemNameError.validate = item.itemName;
        itemNameError.value = item.itemName.$model;
        arrErrorMessage.push(CommonService.getErrorMessage(itemNameError));
        this.arrItemError.set(itemInfo + i + itemName, true);
      }

      if (this.errors.get(itemInfo + i + itemName)) {
        arrErrorMessage.push(this.errors.get(itemInfo + i + itemName));
      }

      if (item.hsCd.$error) {
        hsCdError.validate = item.hsCd;
        hsCdError.value = item.hsCd.$model;
        arrErrorMessage.push(CommonService.getErrorMessage(hsCdError));
        this.arrItemError.set(itemInfo + i + hsCd, true);
      }

      if (this.errors.get(itemInfo + i + hsCd)) {
        arrErrorMessage.push(this.errors.get(itemInfo + i + hsCd));
      }

      if (item.originCountryId.$error) {
        originCountryError.validate = item.originCountryId;
        originCountryError.value = item.originCountryId.$model;
        arrErrorMessage.push(CommonService.getErrorMessage(originCountryError));
        this.arrItemError.set(itemInfo + i + originCountryId, true);
      }

      if (this.errors.get(itemInfo + i + originCountryId)) {
        arrErrorMessage.push(this.errors.get(itemInfo + i + originCountryId));
      }

      return arrErrorMessage;
    },
    checkItemError2(arrErrorMessage, item, i) {
      const valueOfUnitError = {
        validate: null,
        value: null,
        itemName: this.$t("KYG021001.label.unit_price"),
        maxDigit: "13",
        zeroLable: this.$t("KYG021001.label.unit_price_label")
      };
      const unitCdError = {
        validate: null,
        value: null,
        itemName: this.$t("KYG021001.label.unit"),
        maxDigit: "3"
      };
      const quantityError = {
        validate: null,
        value: null,
        itemName: this.$t("KYG021001.label.quantity"),
        maxDigit: "4",
        zeroLable: this.$t("KYG021001.label.unit_price_label")
      };
      const itemInfo = "itemInfo[";
      const valueOfUnit = "].valueOfUnit";
      const unitCd = "].unitCd";
      const quantity = "].quantity";
      if (item.valueOfUnit.$error) {
        valueOfUnitError.validate = item.valueOfUnit;
        valueOfUnitError.value = item.valueOfUnit.$model;
        arrErrorMessage.push(CommonService.getErrorMessage(valueOfUnitError));
        this.arrItemError.set(itemInfo + i + valueOfUnit, true);
      }

      if (this.errors.get(itemInfo + i + valueOfUnit)) {
        arrErrorMessage.push(this.errors.get(itemInfo + i + valueOfUnit));
      }

      if (item.unitCd.$error) {
        unitCdError.validate = item.unitCd;
        unitCdError.value = item.unitCd.$model;
        arrErrorMessage.push(CommonService.getErrorMessage(unitCdError));
        this.arrItemError.set(itemInfo + i + unitCd, true);
      }

      if (this.errors.get(itemInfo + i + unitCd)) {
        arrErrorMessage.push(this.errors.get(itemInfo + i + unitCd));
      }
      if (item.quantity.$error) {
        quantityError.validate = item.quantity;
        quantityError.value = item.quantity.$model;
        arrErrorMessage.push(CommonService.getErrorMessage(quantityError));
        this.arrItemError.set(itemInfo + i + quantity, true);
      }

      if (this.errors.get(itemInfo + i + quantity)) {
        arrErrorMessage.push(this.errors.get(itemInfo + i + quantity));
      }

      return arrErrorMessage;
    },
    updateListPresent() {
      if (!this.issueInvoiceFlg) {
        return;
      }
      const _vm = this.packageModel;
      const lstTmp = _vm.listItems
        .filter(item => item.itemName !== "")
        .map(item => {
          var key = ("No." + Number(item.no)).padEnd(6);
          if (85 < item.itemName.length) {
            key += item.itemName.substr(0, 85) + "...";
          } else {
            key += item.itemName;
          }
          return { key: key, name: item.itemName };
        });

      this.listRePresents = lstTmp;

      if (!lstTmp.some(item => item.name === _vm.rePresent)) {
        _vm.rePresent = null;
        this.$v.packageModel.rePresent.$reset();
      }
    },
    calculateItemTotal(quantity, valueOfUnit) {
      if (
        quantity &&
        this.isNumber(quantity) &&
        valueOfUnit &&
        this.isNumber(valueOfUnit)
      ) {
        return CommonService.formatNumber(quantity * valueOfUnit);
      }
      return "";
    },
    trimValue(value) {
      return CommonService.trimValue(value);
    },
    changeInvoiceOutDiv(invoiceOutDiv) {
      if (invoiceOutDiv === INVOICE_OUT_DIV.DO_NOT_ISSUE_INVOICE) {
        this.packageModel.listItems = [dummyItem];
        this.packageModel.rePresent = this.displayNonDocumentItem
          ? CONSTANTS.EMPTY_STRING
          : REPRESENTATIVE_ITEM_NAME_DOCUMENT;
        this.packageModel.totalProductPrice = this.displayNonDocumentItem
          ? CONSTANTS.EMPTY_STRING
          : "0";
      } else {
        this.packageModel.listItems = [{ ...emptyItem, del: this.$t(delText) }];
        this.updateListPresent();
      }
      this.rePresentIsReady = false;
      this.totalProductPriceIsReady = false;
      this.$v.packageModel.listItems.$each.$reset();
      CommonService.removeKeyStartsWith(this.errors, "itemInfo\\[");
      this.errors.delete("itemInfo");
      if (this.errorUps) {
        this.errorUps.delete("itemInfo");
      }
      this.getListErrorMessageItems();
      this.$v.packageModel.rePresent.$reset();
      this.errors.delete(this.keyParams.representativeItemName);
      this.$v.packageModel.totalProductPrice.$reset();
      this.errors.delete(this.keyParams.itemTotal);
      this.packageModel.registerItem = false;
    },
    changeCountryCd() {
      // VAT種類のデフォルト設定
      this.packageModel.vatRegisterDiv = null;
      const listVatByCountry = this.dataInit.listVatRegisterCountry.find(
        country => country.countryCd === this.countryCd
      );
      let vatTypeList = null;
      if (listVatByCountry) {
        vatTypeList = listVatByCountry.vatTypeList;
      }
      if (vatTypeList && vatTypeList.length > 0) {
        this.packageModel.vatRegisterDiv = vatTypeList[0].type;
      }
      this.$v.packageModel.vatRegisterDiv.$reset();
      this.changeVatRegisterDiv();
    },
    changeShipmentDiv(newValue, oldValue) {
      if (document.getElementById("rePresentInput")) {
        document.getElementById("rePresentInput").value = null;
      }
      if (newValue === NON_DOCUMENT) {
        this.packageModel.paidDiv = this.packageModel.paidDiv
          ? this.packageModel.paidDiv
          : null;
        this.$v.packageModel.paidDiv.$reset();
        this.packageModel.length = this.packageModel.length
          ? this.packageModel.length
          : null;
        this.$v.packageModel.length.$reset();
        this.packageModel.width = this.packageModel.width
          ? this.packageModel.width
          : null;
        this.$v.packageModel.width.$reset();
        this.packageModel.height = this.packageModel.height
          ? this.packageModel.height
          : null;
        this.$v.packageModel.height.$reset();
        if (oldValue) {
          this.packageModel.paymentDiv = null;
        } else {
          this.packageModel.paymentDiv = this.packageModel.paymentDiv
            ? this.packageModel.paymentDiv
            : null;
        }

        this.$v.packageModel.paymentDiv.$reset();
        // 貨物種別「書類以外の貨物」を選択した場合、選択値が「1:本システムでインボイスを発行する」
        this.packageModel.invoiceOutDiv = INVOICE_OUT_DIV.ISSUE_INVOICE;
      } else {
        this.packageModel.paidDiv = null;
        this.$v.packageModel.paidDiv.$reset();
        this.packageModel.length = null;
        this.$v.packageModel.length.$reset();
        this.packageModel.width = null;
        this.$v.packageModel.width.$reset();
        this.packageModel.height = null;
        this.$v.packageModel.height.$reset();
        this.packageModel.paymentDiv = "2";
        this.$v.packageModel.paymentDiv.$reset();
        // 貨物種別「書類」を選択した場合、選択値が「2:インボイスを発行しない」
        this.packageModel.invoiceOutDiv = INVOICE_OUT_DIV.DO_NOT_ISSUE_INVOICE;
      }
      this.$v.packageModel.invoiceOutDiv.$reset();
      this.changeInvoiceOutDiv(this.packageModel.invoiceOutDiv);
    },
    // VAT登録ブロックの 詳細は「こちら(リンク)」押下時
    showVATSelectionDetail() {
      window.open(url.LINK_YMT_VAT_SELECTION_DETAIL);
    },
    changeVatRegisterDiv() {
      this.$v.packageModel.vatRegisterNumber.$reset();
      this.packageModel.vatRegisterNumber = null;
      this.vatRegistNumberIsReady = false;
      this.errors.delete(this.keyParams.vatRegisterNumber);
      this.errorUps.delete(this.keyParams.vatRegisterNumber);
    },
    //「？(リンク)」押下時
    showHinmokuSetting() {
        window.open(
          url.LINK_ITEM_PRECAUTIONS
        );
    }
  },
  computed: {
    //「お届け先をマスタに登録する」、「ご依頼主マスタに登録する」、「品目マスタに登録する」変更時
    changeRegistData() {
      if (
        this.packageModel.registerAddressee &&
        this.packageModel.registerClient &&
        (!this.issueInvoiceFlg || this.packageModel.registerItem)
      ) {
        return true;
      } else {
        return false;
      }
    },
    validationGrossWeight() {
      const checkWeightConflict = value =>
        CommonService.checkWeightConflict(
          value,
          this.packageModel.grossWeight,
          this.packageModel.netWeight
        );
      const checkOverSize = value =>
        CommonService.checkOverSize(
          value,
          this.serviceKbn,
          this.dataInit.listWeightLimit
        );
      if (this.isActiveGrossWeight) {
        return {
          required,
          checkDecimal,
          checkDecimal6Digit,
          checkOverSize,
          zeroError,
          checkWeightConflict
        };
      } else {
        return {
          required,
          checkDecimal,
          checkDecimal6Digit,
          checkOverSize,
          checkWeightConflict
        };
      }
    },
    validationNetWeight() {
      const checkWeightConflict = value =>
        CommonService.checkWeightConflict(
          value,
          this.packageModel.grossWeight,
          this.packageModel.netWeight
        );
      const checkOverSize = value =>
        CommonService.checkOverSize(
          value,
          this.serviceKbn,
          this.dataInit.listWeightLimit
        );
      if (this.isActiveNetWeight) {
        return {
          checkDecimal,
          checkDecimal6Digit,
          checkOverSize,
          checkWeightConflict
        };
      } else {
        return {
          checkDecimal,
          checkDecimal6Digit,
          checkOverSize,
          checkWeightConflict
        };
      }
    },
    validationHeight() {
      const checkHeight = value =>
        CommonService.checkHeight(
          value,
          this.packageModel.width,
          this.packageModel.length
        );
      const checkOverSizeDemension = value =>
        CommonService.checkOverSizeDemension(
          value,
          this.serviceKbn,
          this.packageModel.height,
          this.packageModel.width,
          this.packageModel.length,
          this.dataInit.listSizeLimit
        );
      if (this.isActiveHeight) {
        return {
          zeroError,
          checkDecimal,
          checkDecimal4Digit,
          checkHeight,
          checkOverSizeDemension
        };
      } else {
        return {
          checkDecimal,
          checkHeight,
          checkDecimal4Digit,
          checkOverSizeDemension
        };
      }
    },
    validationWidth() {
      const checkWidth = value =>
        CommonService.checkWidth(
          this.packageModel.height,
          value,
          this.packageModel.length
        );
      const checkOverSizeDemension = value =>
        CommonService.checkOverSizeDemension(
          value,
          this.serviceKbn,
          this.packageModel.height,
          this.packageModel.width,
          this.packageModel.length,
          this.dataInit.listSizeLimit
        );
      if (this.isActiveWidth) {
        return {
          zeroError,
          checkDecimal,
          checkDecimal4Digit,
          checkWidth,
          checkOverSizeDemension
        };
      } else {
        return {
          checkDecimal,
          checkDecimal4Digit,
          checkWidth,
          checkOverSizeDemension
        };
      }
    },
    validationLength() {
      const checkLength = value =>
        CommonService.checkLength(
          this.packageModel.height,
          this.packageModel.width,
          value
        );
      const checkOverSizeDemension = value =>
        CommonService.checkOverSizeDemension(
          value,
          this.serviceKbn,
          this.packageModel.height,
          this.packageModel.width,
          this.packageModel.length,
          this.dataInit.listSizeLimit
        );
      if (this.isActiveLength) {
        return {
          zeroError,
          checkDecimal,
          checkDecimal4Digit,
          checkLength,
          checkOverSizeDemension
        };
      } else {
        return {
          checkDecimal,
          checkDecimal4Digit,
          checkLength,
          checkOverSizeDemension
        };
      }
    },
    // インボイス発行
    listInvoiceOutDiv() {
      if (this.shipmentDiv === NON_DOCUMENT) {
        return this.dataInit.listInvoiceByNonDocument;
      } else {
        return this.dataInit.listInvoiceByDocument;
      }
    },
    issueInvoiceFlg() {
      return this.packageModel.invoiceOutDiv === INVOICE_OUT_DIV.ISSUE_INVOICE;
    },
    displayNonDocumentItem() {
      return this.shipmentDiv === NON_DOCUMENT;
    },
    // VAT種類
    listVatInputDiv() {
      const vatTypeList = this.dataInit.listVatRegisterCountry.find(
        country => country.countryCd === this.countryCd
      ).vatTypeList;
      const vatRegisterDivList = this.dataInit.listVatRegisterDiv;
      var listVatInputDiv = new Array();
      for (let i = 0; i < vatRegisterDivList.length; i++) {
        if (
          vatRegisterDivList[i].sbtNaiID ===
          CONSTANTS.VAT_REGISTER_DIV_NOT_REGIST
        ) {
          vatRegisterDivList[i].sortNo = CONSTANTS.VAT_REGISTER_DIV_NOT_REGIST;
          listVatInputDiv.push(vatRegisterDivList[i]);
        } else {
          for (let j = 0; j < vatTypeList.length; j++) {
            if (vatTypeList[j].type === vatRegisterDivList[i].sbtNaiID) {
              vatRegisterDivList[i].sortNo = vatTypeList[j].sortNo;
              listVatInputDiv.push(vatRegisterDivList[i]);
            }
          }
        }
      }
      return listVatInputDiv.sort(CommonService.fieldSorter(["sortNo"], "ASC"));
    },
    vatInputPlaceholder() {
      const vatTypeList = this.dataInit.listVatRegisterCountry.find(
        country => country.countryCd === this.countryCd
      ).vatTypeList;
      var selectedVatType = this.packageModel.vatRegisterDiv;
      if (
        !selectedVatType ||
        selectedVatType === CONSTANTS.VAT_REGISTER_DIV_NOT_REGIST
      ) {
        selectedVatType = vatTypeList[0].type;
      }
      return this.dataInit.listVatRegisterHint.find(
        registerHint => registerHint.sbtNaiID === selectedVatType
      ).stringValue;
    },
    vatSelectionDetail() {
      const vatTypeList = this.dataInit.listVatRegisterCountry.find(
        country => country.countryCd === this.countryCd
      ).vatTypeList;
      var selectedVatType = this.packageModel.vatRegisterDiv;
      if (
        !selectedVatType ||
        selectedVatType === CONSTANTS.VAT_REGISTER_DIV_NOT_REGIST
      ) {
        selectedVatType = vatTypeList[0].type;
      }

      return this.dataInit.listVatRegisterNotice.find(
        registerMoney => registerMoney.sbtNaiID === selectedVatType
      ).stringValue;
    },
    isShowVatSetting() {
      const selectedCountry = this.dataInit.listVatRegisterCountry.find(
        country => country.countryCd === this.countryCd
      );
      return (
        selectedCountry &&
        selectedCountry.vatTypeList &&
        selectedCountry.vatTypeList.length > 0
      );
    },
    isShowVatSelectCol3() {
      const selectedCountry = this.dataInit.listVatRegisterCountry.find(
        country => country.countryCd === this.countryCd
      );
      return (
        selectedCountry &&
        selectedCountry.vatTypeList &&
        selectedCountry.vatTypeList.length > 1
      );
    },
    isShowVatNumber() {
      return (
        this.packageModel.vatRegisterDiv !==
        CONSTANTS.VAT_REGISTER_DIV_NOT_REGIST
      );
    }
  }
};
</script>
